
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"20","height":"20","rx":"4","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M9.333 6a1 1 0 10-2 0v8a1 1 0 102 0V6zM6 11a1 1 0 10-2 0v3a1 1 0 102 0v-3zM10.667 7.875a1 1 0 112 0V14a1 1 0 11-2 0V7.875zM16 9.75a1 1 0 10-2 0V14a1 1 0 102 0V9.75z","fill":"#fff"}})])
          )
        }
      }
    